import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import DGTable from 'jquery.dgtable';
import i18n, { t }  from '../../i18n/i18n.js';
import View from '../../../controls/View.js';
import Filter from '../../../controls/Filter.js';
import FiltersController from '../../../appHelpers/FiltersController.js';
import DropDownBox from '../../../controls/DropDownBox.js';
import PhoneNumberUtil from '../../../utils/PhoneNumberUtil.mjs';
import ResizeManager from '../../../utils/ResizeManager.js';
import ContactInfoPopup from '../../popups/ContactInfoPopup.js';
import app from '../../App.js';
import TableContextMenuUtil from '../../../appHelpers/TableContextMenu.js';
import TimeFormatters from '../../../appHelpers/TimeFormatters.js';
import {CONTACT_BASIC_FIELDS} from "../../../Globals";

/** @class CallEventsReportPage */
const CallEventsReportPage = View.extend(
    /** @lends CallEventsReportPage.prototype */
    {

        className: 'main-body',

        events: {
            'change #join-contact-fields': 'onJoinContactChange',
            'change #show-only-last': 'onOnlyLastChange'
        },

        /** @constructs */
        initialize: function () { //TODO: When team column is displayed - add a note: "The team is not necessarily the team the user really belongs to when the call has been made, it's only the current team of the user."

            var that = this;

            // Add the title for this screen
            var $title = $('<div class="main-title">').appendTo(that.$el);
            $('<h1 class="main">').text(t('call_events_report.title')).appendTo($title);

            // Setup the space for action buttons
            var $buttonsBar = $('<div class="action-buttons">').append(
                $('<button class="action-refresh-button">').attr('title', t('refresh')).on('click', that.reload.bind(that))
            ).appendTo($title);

            // Create the AUDIO object through which we play the recordings
            that.$player = $('<audio>');

            // Create the dropdown for the download actions
            that.downloadDdl = new DropDownBox({ className: 'dropdown-action-download-box', defaultText: '', allowEmpty: true,
                position: 'end top',
                anchor: 'end bottom' })
                .addItem('csv', t('export_options', 'csv'))
                .addItem('xml', t('export_options', 'xml'));
            that.listenTo(that.downloadDdl, 'change', function () {
                const action = that.downloadDdl.val();
                that.downloadDdl.val(null);

                if (action === 'csv') {
                    that.exportAction(action);
                } else if (action === 'xml') {
                    that.exportAction(action);
                }

            });
            that.downloadDdl.$el.appendTo($buttonsBar);

            // Load settings
            that.joinContactFields = app.getUserSetting('call_session_report_join_contact') || false;
            that.showOnlyLast = app.getUserSetting('call_session_report_only_last') || false;

            that.$joinContactToogle = $('<div class="action-toggle-with-label">').append(
                $('<label for="join-contact-fields">').text(t('call_events_report.join_contact_fields')),
                $('<div class="boolean-toggle">').append(
                    $('<input id="join-contact-fields" type="checkbox">').prop('checked', that.joinContactFields),
                    $('<label for="join-contact-fields">')
                )
            ).appendTo($buttonsBar);

            that.$showOnlyLast = $('<div class="action-toggle-with-label">').append(
                $('<label for="show-only-last">').text(t('call_events_report.only_last')),
                $('<div class="boolean-toggle">').append(
                    $('<input id="show-only-last" type="checkbox">').prop('checked', that.showOnlyLast),
                    $('<label for="show-only-last">')
                )
            ).appendTo($buttonsBar);

            // Add the filters area
            that.$filtersArea = $('<div class="filters-area">').appendTo(that.$el).on('resize', function(){
                that.adjustSplitFrame();
            });

            // Create the space for the table and its preview data
            that.$splitArea = $('<div class="report-split-area"><div class="table-wrapper"></div><div class="data-area"></div></div>').appendTo(that.$el);

            // Setup the filters
            that.setupFilters();

            // Setup the table, and its automatic adjusting to its frame
            that.setupTable();
            that.table.render();
            that.listenTo(ResizeManager, 'resize', that.adjustSplitFrame);
            that.setTimeout(function () { that.adjustSplitFrame(); }, 0);

            that.reload();
        },

        setupFilters: function () {
            var that = this;

            var getFilterIds = function (key) {
                return (((that._filters.getValues(key, true) || {})[key] || {})['value'] || []).map(x => x.value).join(',');
            };

            var filterConfiguration = {
                'session_id': {
                    label: t('call_events_report.filters.session_id'),
                    type: Filter.FilterType.NUMBER
                },
                'contact_id': {
                    label: t('call_events_report.filters.contact_id'),
                    type: Filter.FilterType.NUMBER
                },
                'contact_all_phones': {
                    label: t('call_events_report.filters.contact_phones'),
                    type: Filter.FilterType.TEXT
                },
                'dialed_phone': {
                    label: t('call_events_report.filters.dialed_phone'),
                    type: Filter.FilterType.TEXT
                },
                'team_id': {
                    label: t('filters.team'),
                    type: Filter.FilterType.MULTIOPTION,
                    source: function (request, response) {
                        var params = {
                            'fields': 'id,name'
                        };
                        if (this._xhr) {
                            this._xhr.abort();
                        }
                        this._xhr = $.ajax({
                            url: app.apiUrl('teams', params),
                            dataType: "json",
                            success: function (data) {
                                response(_.map(data, function (value) {
                                    return {
                                        value: value['id'],
                                        label: value['name']
                                    };
                                }));
                            },
                            error: function () { response([]); }
                        });
                    },
                    cacheSource: true
                },
                'user_id': {
                    label: t('filters.user_representative'),
                    type: Filter.FilterType.MULTIOPTION,
                    source: function (request, response) {
                        var params = {
                            'fields': 'id,first_name,last_name',
                            'team_id': getFilterIds('team_id')
                        };
                        if (this._xhr) {
                            this._xhr.abort();
                        }
                        this._xhr = $.ajax({
                            url: app.apiUrl('users', params),
                            dataType: "json",
                            success: function (data) {
                                response(_.map(data, function (value) {
                                    return {
                                        value: value['id'],
                                        label: ((value['first_name'] || '') + ' ' + (value['last_name'] || '')).trim()
                                    };
                                }));
                            },
                            error: function () { response([]); }
                        });
                    },
                    cacheSource: true
                },
                'project_id': {
                    label: t('filters.project'),
                    type: Filter.FilterType.MULTIOPTION,
                    source: function (request, response) {
                        var params = {
                            'fields': 'id,name'
                        };
                        if (this._xhr) {
                            this._xhr.abort();
                        }
                        this._xhr = $.ajax({
                            url: app.apiUrl('projects', params),
                            dataType: "json",
                            success: function (data) {
                                response(_.map(data, function (value) {
                                    return {
                                        value: value['id'],
                                        label: value['name']
                                    };
                                }));
                            },
                            error: function () { response([]); }
                        });
                    },
                    cacheSource: true
                },
                'campaign_id': {
                    label: t('filters.campaign'),
                    type: Filter.FilterType.MULTIOPTION,
                    source: function (request, response) {
                        var params = {
                            'fields': 'id,name',
                            'project_id': getFilterIds('project_id')
                        };
                        if (this._xhr) {
                            this._xhr.abort();
                        }
                        this._xhr = $.ajax({
                            url: app.apiUrl('campaigns', params),
                            dataType: "json",
                            success: function (data) {
                                response(_.map(data, function (value) {
                                    return {
                                        value: value['id'],
                                        label: value['name']
                                    };
                                }));
                            },
                            error: function () { response([]); }
                        });
                    },
                    cacheSource: true
                },
                'start_time': {
                    label: t('filters.start_date'),
                    type: Filter.FilterType.DATETIME
                },
                'end_time': {
                    label: t('filters.end_date'),
                    type: Filter.FilterType.DATETIME
                },
                'type': {
                    label: t('call_events_report.filters.type'),
                    type: Filter.FilterType.MULTIOPTION,
                    source: t('call_events_report.type_options')
                },
                'status': {
                    label: t('call_events_report.filters.status'),
                    type: Filter.FilterType.MULTIOPTION,
                    source: t('call_events_report.status_options')
                },
                'continue_reason_id': {
                    label: t('filters.continue_reason'),
                    type: Filter.FilterType.MULTIOPTION,
                    source: function (request, response) {
                        var params = {
                            'project_id': getFilterIds('project_id'),
                            'defaults': 'yes'
                        };
                        if (this._xhr) {
                            this._xhr.abort();
                        }
                        this._xhr = $.ajax({
                            url: app.apiUrl('continue_reasons', params),
                            dataType: "json",
                            success: function (data) {
                                response(_.map(data, function (value) {
                                    return {
                                        value: value['id'],
                                        label: value['name']
                                    };
                                }));
                            },
                            error: function () { response([]); }
                        });
                    }
                },
                'end_reason_id': {
                    label: t('filters.end_reason'),
                    type: Filter.FilterType.MULTIOPTION,
                    source: function (request, response) {
                        var params = {
                            'project_id': getFilterIds('project_id'),
                            'defaults': 'yes'
                        };
                        if (this._xhr) {
                            this._xhr.abort();
                        }
                        this._xhr = $.ajax({
                            url: app.apiUrl('end_reasons', params),
                            dataType: "json",
                            success: function (data) {
                                response(_.map(data, function (value) {
                                    return {
                                        value: value['id'],
                                        label: value['name']
                                    };
                                }));
                            },
                            error: function () { response([]); }
                        });
                    }
                }
            };

            var queryFilters = null;
            var queryString = Backbone.history.getFragment().getQueryStringParams();
            if (queryString['filters']) {
                try {
                    queryFilters = JSON.parse(decodeURIComponent(atob(queryString['filters'])));
                } catch (e) { }
            }

            that._filters = new FiltersController({
                config: filterConfiguration,
                util: {
                    i18n: i18n,
                    getUserSetting: app.getUserSetting,
                    setUserSetting: app.setUserSetting,
                },
                saveKey: 'call_events_report',
                startWithValues: queryFilters,
                $panel: that.$filtersArea,
                callback: function (filterValues, type, action, value, andValue, mode) {
                    that.reload();
                    if (type === 'team_id') {
                        that._filters
                            .clearAutoCompleteCache('user_id')
                            .clearAutoCompleteCache('project_id')
                            .clearAutoCompleteCache('campaign_id');
                    }
                    else if (type === 'user_id') {
                        that._filters
                            .clearAutoCompleteCache('project_id')
                            .clearAutoCompleteCache('campaign_id');
                    }
                    else if (type === 'project_id') {
                        that._filters
                            .clearAutoCompleteCache('campaign_id');
                    }
                }
            });

            return that;
        },

        setupTable: function () {
            var that = this;

            var columns = [
                {name: 'contact_id', label: t('call_events_report.columns.contact_id')},
                {name: 'contact', label: t('call_events_report.columns.contact')},
                {name: 'campaign_name', label: t('call_events_report.columns.campaign_name')},
                {name: 'user', label: t('call_events_report.columns.user')},
                {name: 'team', label: t('call_events_report.columns.team')},
                {name: 'start_time', label: t('call_events_report.columns.start_time')},
                {name: 'end_time', label: t('call_events_report.columns.end_time')},
                {name: 'type', label: t('call_events_report.columns.type')},
                {name: 'status', label: t('call_events_report.columns.status')},
                {name: 'continue_reason_name', label: t('call_events_report.columns.continue_reason_name')},
                {name: 'continue_by', label: t('call_events_report.columns.continue_by')},
                {name: 'end_reason_name', label: t('call_events_report.columns.end_reason_name')},
                {name: 'comment', label: t('call_events_report.columns.comment')}
            ];

            var tableConfigKey = 'call_events_report';
            app.TableAutoSavingConfigUtil.load(columns, tableConfigKey);

            var dateFormat = t('date_formats.normal_date_short_time');
            var typeOptions = t('call_events_report', 'type_options');
            var statusOptions = t('call_events_report', 'status_options');

            var table = that.table = new DGTable({
                el: that.$splitArea.find('.table-wrapper')[0],
                columns: columns,
                width: DGTable.Width.SCROLL,
                convertColumnWidthsToRelative: true,
                cellFormatter: function (val, colName, row) {
                    if (colName === 'contact') {
                        return ((row['contact_first_name'] || '') + ' ' + (row['contact_last_name'] || '')).trim() || row['contact_id'];
                    } else if (colName === 'user') {
                        return (row['user_first_name'] || '') + ' ' + (row['user_last_name'] || '');
                    } else if (colName === 'team') {
                        return row['team_name'];
                    } else if (colName === 'continue_by') {
                        return (row['continue_by_first_name'] || '') + ' ' + (row['continue_by_last_name'] || '');
                    } else if (colName === 'start_time' || colName === 'end_time') {
                        return val ? i18n.formatDate(new Date(val), dateFormat) : '';
                    } else if (colName === 'type') {
                        return typeOptions[val];
                    } else if (colName === 'status') {
                        return statusOptions[val];
                    }
                    return val;
                },
                comparatorCallback: function (columnName, descending) {
                    var leftValue = descending ? 1 : -1,
                        rightValue = descending ? -1 : 1;
                    if (columnName === 'contact') {
                        return function (a, b) {
                            if (a['contact_first_name'] < b['contact_first_name']) return leftValue;
                            if (a['contact_first_name'] > b['contact_first_name']) return rightValue;
                            if (a['contact_last_name'] < b['contact_last_name']) return leftValue;
                            if (a['contact_last_name'] > b['contact_last_name']) return rightValue;

                            const aName = !!((a['contact_first_name'] || '') + ' ' + (a['contact_last_name'] || '')).trim(),
                                bName = !!((b['contact_first_name'] || '') + ' ' + (b['contact_last_name'] || '')).trim();
                            if (!aName && bName) return rightValue;
                            if (!bName && aName) return leftValue;
                            
                            if (a['contact_id'] < b['contact_id']) return rightValue;
                            if (a['contact_id'] > b['contact_id']) return leftValue;
                            return 0;
                        };
                    }
                    else if (columnName === 'user') {
                        return function (a, b) {
                            if (a['user_first_name'] < b['user_first_name']) return leftValue;
                            if (a['user_first_name'] > b['user_first_name']) return rightValue;
                            if (a['user_last_name'] < b['user_last_name']) return leftValue;
                            if (a['user_last_name'] > b['user_last_name']) return rightValue;
                            return 0;
                        };
                    }
                    else if (columnName === 'continue_by') {
                        return function (a, b) {
                            if (a['continue_by_first_name'] < b['continue_by_first_name']) return leftValue;
                            if (a['continue_by_first_name'] > b['continue_by_first_name']) return rightValue;
                            if (a['continue_by_last_name'] < b['continue_by_last_name']) return leftValue;
                            if (a['continue_by_last_name'] > b['continue_by_last_name']) return rightValue;
                            if (!a['continue_by_first_name'] && !a['continue_by_last_name']) return rightValue;
                            return leftValue

                        };
                    }
                    else if (columnName === 'team') {
                        return function (a, b) {
                            if (a['team_name'] < b['team_name']) return leftValue;
                            if (a['team_name'] > b['team_name']) return rightValue;
                            if (!a['team_name']) return rightValue;
                            return leftValue;
                        };
                    }
                    return null;
                }
            });

            app.TableAutoSavingConfigUtil.setup(table, tableConfigKey);

            table.on('rowcreate', function (filteredIndex, index, row, rowData) {

                row.className += index % 2 ? ' alt-row' : ' normal-row';

                if (that._selectedRow && that._selectedRow['id'] === rowData['id']) {
                    row.className += ' selected';
                }
                $(row).click(function () {
                    handleRowSelection(row, row, rowData);
                });

            }).on('cellpreview', function (el, rowIndex, col, rowData) {

                $(el).click(function () {
                    handleRowSelection(el, table.getRowElement(rowIndex), rowData);
                });

            }).on('rowdestroy', function (row) {

            }).on('headercontextmenu', function (columnName, pageX, pageY, cellBounds) {
                TableContextMenuUtil.setup(table, pageX, pageY);
                $.disableContextMenuForCurrentEvent();
            });

            var handleRowSelection = function (el, row, rowData) {

                if (that._selectedRow && that._selectedRow['id'] === rowData['id']) {
                    that.setSelectedRow();
                } else {
                    if (that._selectedRow) {
                        $(row.parentNode).find('.dgtable-row').removeClass('selected');
                    }
                    row.className += ' selected';
                    that.setSelectedRow(rowData);
                }

                if ($(el).closest('.dgtable-cell-preview').length) {
                    that.table.hideCellPreview();
                }
            };

            return that;
        },

        adjustSplitFrame: function () {
            var that = this;

            var $offsetParent = that.$splitArea.offsetParent();
            var offsetTop = that.$splitArea.offset().top - $offsetParent.offset().top;
            that.$splitArea.css({ 'height': $offsetParent.height() - offsetTop - 20 });

            if (that.table) {
                var lastTableSize = that._lastTableSize;
                var tableSize = {
                    width: that.table.$el.offsetParent().width(),
                    height: that.table.$el.offsetParent().height()
                };

                if (!lastTableSize || tableSize.height != lastTableSize.height) {
                    that.table.tableHeightChanged();
                } else if (!lastTableSize || tableSize.width != lastTableSize.width) {
                    that.table.tableWidthChanged();
                }
                that._lastTableSize = tableSize;
            }
            return that;
        },

        reload: function () {
            var that = this;

            if (that._isLoading) return that;

            var fields = [
                'id',
                'contact_id', 'campaign_id',
                'user_id', 'team_id', 'team_name',
                'start_time', 'end_time',
                'type', 'status',
                'continue_reason_id', 'continue_by', 'end_reason_id',
                'comment',
                'continue_reason_name',
                'continue_by_first_name',
                'continue_by_last_name',
                'end_reason_name',
                'user_first_name',
                'user_last_name',
                'campaign_name',
                'contact_first_name',
                'contact_last_name'
            ];
            fields = fields.join(',');

            const params = { 'fields': fields, 'filters': JSON.stringify(that._filters.getValues(true)) };

            if (that.showOnlyLast) {
                params['only_last'] = true;
            }

            that._isLoading = true;
            that.ajaxGet(app.apiUrl('call_sessions'), params)
                .always(function () {
                    that._isLoading = false;
                })
                .then(function (data) {
                    that.table.setRows(data, true);

                    var continueReasonStats = {}, endReasonStats = {};
                    for (var i = 0, len = data.length; i < len; i++) {
                        var item = data[i];
                        if (item['continue_reason_id']) {
                            if (continueReasonStats[item['continue_reason_name'] || '']) {
                                continueReasonStats[item['continue_reason_name'] || '']++;
                            } else {
                                continueReasonStats[item['continue_reason_name'] || ''] = 1;
                            }
                        }
                        else if (item['end_reason_id']) {
                            if (endReasonStats[item['end_reason_name'] || '']) {
                                endReasonStats[item['end_reason_name'] || '']++;
                            } else {
                                endReasonStats[item['end_reason_name'] || ''] = 1;
                            }
                        }
                    }

                    that._continueReasonStats = continueReasonStats;
                    that._endReasonStats = endReasonStats;
                })
                .fail(function (xhr, error) {
                    app.showXhrError(xhr, error);
                });

            return that;
        },

        render: function () {

            var that = this;

            return this;
        },

        onJoinContactChange: function (evt) {
            this.joinContactFields = !!evt.target.checked;
            app.setUserSetting('call_session_report_join_contact', this.joinContactFields);
        },

        onOnlyLastChange: function (evt) {
            this.showOnlyLast = !!evt.target.checked;
            app.setUserSetting('call_session_show_only_last', this.showOnlyLast);
            this.reload();
        },

        getSessionCallHistory: function (sessionId) {
            var that = this;

            if (that._isLoading) return that;

            var fields = [
                'id',
                'start_time',
                'status',
                'phone',
                'answered_on',
                'disconnected_on',
                'ami_uniqueid',
                'gross_duration',
                'net_duration'
            ];
            fields = fields.join(',');

            that._isLoading = true;
            that.ajaxGet(app.apiUrl('call_history'), { 'fields': fields, 'filters': JSON.stringify( { 'call_session_id': { 'mode':'=', 'value': sessionId } } ) })
                .always(function () {
                    that._isLoading = false;
                })
                .then(function (data) {

                    that._results = data;
                    that.renderCallHistoryTable()
                })
                .fail(function (xhr, error) {
                    app.showXhrError(xhr, error);
                });

            return that;
        },

        renderCallHistoryTable: function () {

            var createActionButtons = function ($cell, rowData) {
                var uniqueid = rowData['ami_uniqueid'];

                var $el = $cell.find('.row-player');
                if (!$el.length) return;

                var $player = that.$player;
                var player = $player[0];

                $el.find('>.play-pause').on('click', function () {

                    if ($el.hasClass('playing')) {
                        that.pauseRecordingByUniqueId(uniqueid);
                    }
                    else {
                        that.playRecordingByUniqueId(uniqueid);
                        that.$barControlArea.show();
                    }

                });

                $el.find('>.stop').on('click', function () {

                    that.stopRecordingByUniqueId(uniqueid);
                    that.$barControlArea.hide();

                });

                $el.find('>.download').on('click', function () {

                    var $a = $('<a>').attr('download', uniqueid + '.mp3').attr('href', that.streamUrl(uniqueid)).appendTo(document.body).on('click', function (event) {
                        event.stopPropagation(); // Prevent Router handlers from catching this
                    });
                    if ($a[0].click) {
                        $a[0].click();
                    } else {
                        $a.click();
                    }
                    $a.remove();

                });

                $player.on('play', function () {
                    if ($player.attr('uniqueid') === uniqueid) {
                        $el[0].className = 'row-player playing';
                    }
                }).on('pause', function () {
                    if ($player.attr('uniqueid') === uniqueid) {
                        $el[0].className = (player.currentTime === 0 || player.currentTime === player.duration) ? 'row-player stopped' : 'row-player paused';
                    }
                }).on('abort', function () {
                    if ($player.attr('uniqueid') === uniqueid) {
                        $el[0].className = 'row-player stopped';
                    }
                }).on('error', function () {
                    if ($player.attr('uniqueid') === uniqueid) {
                        $el[0].className = 'row-player stopped';
                    }
                }).on('ended', function () {
                    if ($player.attr('uniqueid') === uniqueid) {
                        $el[0].className = 'row-player stopped';
                    }
                });

                var updateStatus = function () {
                    $el[0].className = 'row-player ' + ($player.attr('uniqueid') === uniqueid ?
                        (player.paused ?
                            (player.currentTime > 0 && player.currentTime < player.duration ? 'paused' : 'stopped') :
                            'playing') : 'stopped');
                };
                updateStatus();
            };

            var that = this,
                $tbody = that.$tbody;

            $tbody.empty();

            if (that._results && that._results.length) {

                var dateFormat = t('date_formats.short_time');
                var statusOptions = t('call_history_statuses');

                that._results.forEach(function (item) {
                    var $tr = $('<tr>');
                    $('<td>').text(PhoneNumberUtil.displayPhoneNumber(item['phone'] || '')).appendTo($tr);
                    $('<td>').text(TimeFormatters.timeFromSeconds(item['net_duration'])).appendTo($tr);
                    $('<td>').text(statusOptions[item['status']]).appendTo($tr);
                    $('<td>').text(item['start_time'] ? i18n.formatDate(new Date(item['start_time']), dateFormat) : '').appendTo($tr);
                    $('<td>').append($('<div class="row-player stopped"><button class="play-pause"></button><button class="stop"></button><button class="download"></button></div>')).appendTo($tr);

                    createActionButtons($tr, item);

                    $tr.appendTo($tbody);
                });

            }

            return that;
        },

        streamUrl: function (uniqueid) {
            return app.apiUrl('recordings/stream', { 'uniqueid': uniqueid }, false);
        },

        playRecordingByUniqueId: function (uniqueid) {
            var that = this;

            if (that.$player.attr('uniqueid') !== uniqueid) {
                that.$player[0].src = '';
                that.$player.trigger('abort');

                that.$player.attr('uniqueid', uniqueid);
                that.$player[0].src = that.streamUrl(uniqueid);
            }

            that.$player[0].play();

            return that;
        },

        pauseRecordingByUniqueId: function (uniqueid) {
            var that = this;

            if (that.$player.attr('uniqueid') === uniqueid) {
                that.$player[0].pause();
            }

            return that;
        },

        stopRecordingByUniqueId: function (uniqueid) {
            var that = this;

            if (that.$player.attr('uniqueid') === uniqueid) {
                that.$player[0].pause();
                that.$player[0].currentTime = 0;
            }

            return that;
        },
        //TODO: t('recordings_list', 'disposition_options', val)

        setupPlayerBar: function () {
            var that = this;

            // Add the player-bar area
            that.$barControlArea = $('\
            <div class="player-bar-area">\
                <div class="timer"></div>\
                <div class="bar">\
                  <div class="bar-handle"></div>\
                </div>\
            </div>').appendTo(that.$history);

            var $timer = that.$barControlArea.find('.timer'),
                $bar = that.$barControlArea.find('.bar'),
                $handle = that.$barControlArea.find('.bar-handle'),
                $player = that.$player,
                player = $player[0];

            var calculateValueForBar = function (x, barBounds, handleWidth) {
                var effectiveWidth = barBounds.width - handleWidth;
                return Math.min(Math.max(x - barBounds.left, 0), effectiveWidth) / effectiveWidth;
            };

            var updateBarPosition = function (event, updatePlayerTime) {

                var value,
                    barBounds = $bar[0].getBoundingClientRect(),
                    handleWidth = $handle.outerWidth();

                if (arguments[0] instanceof Event || arguments[0] instanceof $.Event) {
                    value = calculateValueForBar(arguments[0].pageX, barBounds, handleWidth);
                } else {
                    value = arguments[0];
                }

                $handle.css({
                    'left': value * (barBounds.width - handleWidth)
                });

                if (updatePlayerTime) {
                    $player[0].currentTime = (player.duration * value) || 0;
                }

            };

            var updateTimerDisplay = function () {

                var currentPosition = player.currentTime || 0;
                var totalTime = player.duration || 0;

                var newText = '';

                if (player.error) {
                    newText = 'ERR';
                } else {
                    newText = TimeFormatters.timeFromSeconds(currentPosition) +
                        " / " +
                        TimeFormatters.timeFromSeconds(totalTime);
                }

                // If we want to select and copy timer, do not blink
                if ($timer.text() != newText) {
                    $timer.text(newText);
                }

                updateBarPosition((currentPosition / totalTime) || 0);

            };

            var beginDragging = function (event) {

                $(window).on('mousemove.draggable-player-bar', function (event) {

                    event.preventDefault(); // Prevent selection, as `user-select` CSS is not enough
                    updateBarPosition(event, true);

                }).on('mouseup.draggable-player-bar', function (event) {

                    $(window).off('.draggable-player-bar');

                    updateBarPosition(event, true);

                });

                updateBarPosition(event);
            };

            $handle.on('mousedown', function (event) {
                if (event.which !== 1) return; // Only with left button

                beginDragging(event);
            });

            $bar.on('mousedown', function (event) {
                if (event.which !== 1) return; // Only with left button
                if (event.target === $handle[0] || $handle.has(event.target).length) return;
                beginDragging(event);
            });

            $player.on('timeupdate', _.throttle(function() {
                updateTimerDisplay();
            }, 30)).on('loadstart', function() {
                updateTimerDisplay();
            }).on('error', function() {
                updateTimerDisplay();
            }).on('durationchange', function() {
                updateTimerDisplay();
            });

            that.$barControlArea.hide();

            return that;
        },

        setSelectedRow: function (row) {
            var that = this;
            that._selectedRow = row;

            if (!!row !== that.$splitArea.hasClass('is-split')) {
                that.$splitArea.toggleClass('is-split');
                that.table.tableHeightChanged();
            }

            that.$splitArea.find('.data-area').empty();

            if (!row) {
                return that;
            }

            var $panel = $('<div class="call-events-report-panel"><div class="history-area"></div><div class="sums-area"></div></div>').appendTo(that.$splitArea.find('.data-area'));

            if (true) {
                var $sums = $panel.find('>.sums-area');

                $sums.append(i18n.processLocalizedString('<div class="total-sum">{total_record_count_label} {{count}}</div>', { 'count': that.table.getRowCount() }));

                // Add the title for sumTable
                var sumTitle = $('<div class="sub-title">').appendTo($sums);
                $('<h2 class="main">').text(t('call_events_report.sum_area.title')).appendTo(sumTitle);

                var $sumSums = $('<div class="sub-sums">').appendTo($sums);

                if (that._continueReasonStats && Object.keys(that._continueReasonStats).length) {
                    var $continueReasons = $('<div class="continue-reasons">').appendTo($sumSums);
                    var $continueReasonRows = $('<div class="reason-rows">').appendTo($continueReasons);
                    Object.keys(that._continueReasonStats).sort().forEach(function (key) {
                        $('<div class="reason-row">').append($('<div>').text(key)).append($('<div>').text(that._continueReasonStats[key])).appendTo($continueReasonRows);
                    });
                    $sums.addClass('has-continue');
                }

                if (that._endReasonStats && Object.keys(that._endReasonStats).length) {
                    var $endReasons = $('<div class="end-reasons">').appendTo($sumSums);
                    var $endReasonRows = $('<div class="reason-rows">').appendTo($endReasons);
                    Object.keys(that._endReasonStats).sort().forEach(function (key) {
                        $('<div class="reason-row">').append($('<div>').text(key)).append($('<div>').text(that._endReasonStats[key])).appendTo($endReasonRows);
                    });
                    $sums.addClass('has-end');
                }
            }

            if (true) {
                var $history = that.$history = $panel.find('>.history-area');

                // Add the title for historyTable
                var $historyTitle = $('<div class="sub-title">').appendTo($history);
                $('<h2 class="main">').text(t('call_events_report.recordings.title')).appendTo($historyTitle);

                var $historyTable  = $('<table class="simple-report">');
                $('<thead>').html(i18n.processLocalizedString('<tr>' +
                    '<th>{call_history_report.columns.phone}</th>' +
                    '<th>{call_history_report.columns.net_duration}</th>' +
                    '<th>{call_history_report.columns.status}</th>' +
                    '<th>{call_history_report.columns.start_time}</th>' +
                    '<th>{call_history_report.columns.play_record}</th>' +
                    '</tr>')).appendTo($historyTable);
                that.$tbody = $('<tbody>').appendTo($historyTable);

                $historyTable.appendTo($history);

                // Add the player bar
                this.setupPlayerBar();

                that.getSessionCallHistory(parseInt(row['id'], 10));

                //Add some important buttons
                $('<button class="row-more-button">').text(t('leads_list.columns.actions.more_details')).click(function () {
                    that.showContactDetailsPopup(row);
                }).appendTo($history);

            }

            return that;
        },

        showContactDetailsPopup: function (row) {
            var that = this;
            var popup = new ContactInfoPopup({ contactId: row['contact_id'], contactName: ((row['contact_first_name'] || '') + ' ' + (row['contact_last_name'] || '')).trim() });
            popup.show();

            return that;
        },

        /**
         *
         * @param {String} format
         */
        exportAction: function (format) {
            var that = this;

            var exportLoc = {
                'type_options': t('call_events_report.type_options'),
                'status_options': t('call_events_report.status_options'),
                'columns': t('call_events_report.columns')
            };

            var exportColumns = that.table.getColumnsConfig();
            exportColumns = Object.keys(exportColumns).filter(function (col) {
                return col !== 'actions' && exportColumns[col].visible !== false;
            }).sort(function (a, b) {
                a = exportColumns[a].order;
                b = exportColumns[b].order;
                if (a < b) return -1;
                if (a > b) return 1;
                return 0;
            });

            if (that.joinContactFields) {
                for (const key of CONTACT_BASIC_FIELDS) {
                    exportColumns.push(`contact_${key}`);
                    exportLoc.columns[`contact_${key}`] = t('contact_fields', key);
                }
            }

            const params = {
                'export': format,
                'export_columns': exportColumns.join(','),
                'export_lang': i18n.getActiveLanguage(),
                'export_loc': JSON.stringify(exportLoc),
                'filters': JSON.stringify(that._filters.getValues(true))
            };

            if (that.showOnlyLast) {
                params['only_last'] = true;
            }

            var url = app.apiUrl('call_sessions', params);

            var iframe = $('<iframe>').hide().appendTo(document.body).attr('src', url)
                .on('load', function () {
                    // If the IFrame is loaded, then an error has occurred...
                    var responsJSON = null;
                    try {
                        responsJSON = iframe[0].contentDocument.body.textContent;
                        responsJSON = JSON.parse(responsJSON);
                    } catch (e) {

                    }
                    if (responsJSON && responsJSON['error']) {
                        app.showXhrError({ 'responseText': JSON.stringify(responsJSON) });
                    }
                });

            return that;
        },

        remove: function () {
            var that = this;

            if (that._filters) {
                that._filters.destroy();
            }

            that.constructor.__super__.remove.apply(this, arguments);
        }

    }
);

export default CallEventsReportPage
